import styled from "styled-components";

export const AdminDashboardWrapper = styled.div`
  .ant-layout {
    height: 100vh;
  }

  .side-navbar {
    background: #272727;
    color: #ffffff;

    .ant-layout-sider-children {
      display: flex;
      flex-flow: column;
      justify-content: space-between;
    }

    .ant-menu-light {
      background: #272727;
      color: #ffffff;

      .ant-menu-item {
        color: #ffffff;
      }

      .ant-menu-submenu {
        .ant-menu-submenu-title {
          color: #ffffff !important;
          
          .ant-menu-item-icon,
          .ant-menu-title-content {
            color: #ffffff !important;
          }

          .ant-menu-submenu-arrow {
            color: #ffffff !important;
          }

          &:hover {
            .ant-menu-item-icon,
            .ant-menu-title-content,
            .ant-menu-submenu-arrow {
              color: #00ffb2 !important;
            }
          }
        }

        &.ant-menu-submenu-open {
          .ant-menu-submenu-title {
            .ant-menu-item-icon,
            .ant-menu-title-content,
            .ant-menu-submenu-arrow {
              color: #00ffb2 !important;
            }
          }
        }

        .ant-menu-sub {
          background: #1f1f1f !important;
          
          .ant-menu-item {
            color: rgba(255, 255, 255, 0.75);
            padding-left: 48px !important;
            
            &:hover {
              color: #00ffb2;
            }
          }
        }
      }

      .ant-menu-item-active {
        .ant-menu-title-content,
        .ant-menu-item-icon {
          color: #00ffb2;
        }
      }

      .ant-menu-item-selected {
        background: #00ffb2;

        .ant-menu-title-content,
        .ant-menu-item-icon {
          color: #191919;
        }
      }
    }
  }
`;
